import React from "react";

const Messages = () => {
  return <div className="primary">Messages</div>;
};

export default Messages;
